import { BlackPopupRolagem } from "@/components/blog/BlackPopupRolagem";
import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { artigoComPopupRolagem } from "@/components/blackfeo/BlackfeoPontos";

import { BlogHeader } from "@/components/blog/BlogHeader";
import { BlogFooter } from "@/components/blog/BlogFooter";
import { BlackDestaqueSection } from "@/components/black2x1/BlackDestaqueSection";
import "@/styles/efisio.css";

export const Route = createFileRoute("/e-fisio")({
  component: BlogLayout,
});

function BlogLayout() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const m = path.match(/^\/e-fisio\/([^/]+)\/?$/);
  const artigo = m && m[1] !== "categoria" ? m[1] : null;
  const modo = artigo && artigoComPopupRolagem(artigo) ? "rolagem" : "saida";
  return (
    <div className="efisio-scope min-h-screen">
      <BlogHeader />
      <Outlet />
      <BlackDestaqueSection origem="e-fisio" />
      <BlackPopupRolagem key={modo} origem={artigo ? `efisio-${artigo}` : "efisio"} modo={modo} />
      <BlogFooter />
    </div>
  );
}
